import { createContext, useState, useMemo, useCallback, useEffect, useContext } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';

// src/i18n/catalogs/ru.json
var ru_default = {
  "common.cancel": "\u041E\u0442\u043C\u0435\u043D\u0430",
  "common.confirm": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
  "common.close": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
  "common.save": "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
  "common.delete": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
  "common.search": "\u041F\u043E\u0438\u0441\u043A",
  "common.loading": "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u044E\u2026",
  "common.error": "\u041E\u0448\u0438\u0431\u043A\u0430",
  "common.retry": "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
  "locale.switcher": "\u042F\u0437\u044B\u043A \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430",
  "locale.russian": "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
  "locale.english": "English",
  "locale.switch_to_russian": "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u0430 \u0440\u0443\u0441\u0441\u043A\u0438\u0439",
  "locale.switch_to_english": "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u0430 \u0430\u043D\u0433\u043B\u0438\u0439\u0441\u043A\u0438\u0439",
  "approval.title": "\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
  "approval.approve": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
  "approval.deny": "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C",
  "approval.comment_placeholder": "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 (\u043E\u043F\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E)\u2026",
  "approval.reason_placeholder": "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0438\u044F\u2026",
  "approval.expires_in": "\u0438\u0441\u0442\u0435\u043A\u0430\u0435\u0442 \u0447\u0435\u0440\u0435\u0437",
  "approval.expired": "\u0417\u0430\u043F\u0440\u043E\u0441 \u0438\u0441\u0442\u0451\u043A",
  "cost_meter.aria_label": "\u0421\u0447\u0451\u0442\u0447\u0438\u043A \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432",
  "cost_meter.warning_threshold": "\u0414\u043E\u0441\u0442\u0438\u0433\u043D\u0443\u0442 \u043F\u043E\u0440\u043E\u0433 80% \u0431\u044E\u0434\u0436\u0435\u0442\u0430",
  "cost_meter.hard_stop": "\u0411\u044E\u0434\u0436\u0435\u0442 \u0438\u0441\u0447\u0435\u0440\u043F\u0430\u043D",
  "cost_meter.empty": "\u041D\u0435\u0442 \u0432\u044B\u0437\u043E\u0432\u043E\u0432 \u0432 \u0442\u0435\u043A\u0443\u0449\u0435\u0439 \u0441\u0435\u0441\u0441\u0438\u0438",
  "workspace.switch": "\u0421\u043C\u0435\u043D\u0438\u0442\u044C workspace",
  "workspace.create": "\u0421\u043E\u0437\u0434\u0430\u0442\u044C workspace",
  "workspace.recent": "\u041D\u0435\u0434\u0430\u0432\u043D\u0438\u0435",
  "workspace.all": "\u0412\u0441\u0435 workspaces",
  "workspace.search_placeholder": "\u041F\u043E\u0438\u0441\u043A workspaces\u2026",
  "doc_picker.title": "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
  "doc_picker.search": "\u041F\u043E\u0438\u0441\u043A \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432\u2026",
  "doc_picker.upload": "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C",
  "doc_picker.attach_url": "\u0418\u043B\u0438 \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u043F\u043E URL",
  "doc_picker.empty": "\u0412 \u044D\u0442\u043E\u043C workspace \u043F\u043E\u043A\u0430 \u043D\u0435\u0442 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432.",
  "doc_picker.no_match": "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
  "doc_picker.no_access": "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
  "composer.placeholder": "\u041E\u043F\u0438\u0448\u0438\u0442\u0435 \u0437\u0430\u0434\u0430\u0447\u0443 \u0438\u043B\u0438 \u0437\u0430\u0434\u0430\u0439\u0442\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u2026",
  "composer.send": "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
  "composer.attach": "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0444\u0430\u0439\u043B",
  "composer.voice": "\u0413\u043E\u043B\u043E\u0441\u043E\u0432\u043E\u0439 \u0432\u0432\u043E\u0434",
  "composer.mode.plan": "\u041F\u043B\u0430\u043D",
  "composer.mode.auto": "\u0410\u0432\u0442\u043E",
  "composer.mode.confirm": "\u041F\u043E\u0434\u0442\u0432.",
  "composer.mode.research": "\u0418\u0441\u0441\u043B\u0435\u0434.",
  "composer.mode.chat": "\u0427\u0430\u0442"
};

// src/i18n/catalogs/en.json
var en_default = {
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.close": "Close",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.search": "Search",
  "common.loading": "Loading\u2026",
  "common.error": "Error",
  "common.retry": "Retry",
  "locale.switcher": "Interface language",
  "locale.russian": "Russian",
  "locale.english": "English",
  "locale.switch_to_russian": "Switch to Russian",
  "locale.switch_to_english": "Switch to English",
  "approval.title": "Approval required",
  "approval.approve": "Approve",
  "approval.deny": "Deny",
  "approval.comment_placeholder": "Optional comment\u2026",
  "approval.reason_placeholder": "Reason for denying\u2026",
  "approval.expires_in": "expires in",
  "approval.expired": "Request expired",
  "cost_meter.aria_label": "Cost meter",
  "cost_meter.warning_threshold": "80% of budget reached",
  "cost_meter.hard_stop": "Budget exhausted",
  "cost_meter.empty": "No tool calls yet in this session",
  "workspace.switch": "Switch workspace",
  "workspace.create": "Create workspace",
  "workspace.recent": "Recent",
  "workspace.all": "All workspaces",
  "workspace.search_placeholder": "Search workspaces\u2026",
  "doc_picker.title": "Attach documents",
  "doc_picker.search": "Search documents\u2026",
  "doc_picker.upload": "Upload",
  "doc_picker.attach_url": "Or attach by URL",
  "doc_picker.empty": "No documents in this workspace yet.",
  "doc_picker.no_match": "No matches found.",
  "doc_picker.no_access": "No access",
  "composer.placeholder": "Describe the task or ask a question\u2026",
  "composer.send": "Send",
  "composer.attach": "Attach file",
  "composer.voice": "Voice input",
  "composer.mode.plan": "Plan",
  "composer.mode.auto": "Auto",
  "composer.mode.confirm": "Confirm",
  "composer.mode.research": "Research",
  "composer.mode.chat": "Chat"
};
var DEFAULT_STORAGE_KEY = "iam.locale";
var DEFAULT_CATALOGS = {
  ru: ru_default,
  en: en_default
};
var I18nContext = createContext(void 0);
function normalizeLocale(value, fallback = "ru") {
  const normalized = value?.trim().toLowerCase();
  if (normalized?.startsWith("en")) return "en";
  if (normalized?.startsWith("ru")) return "ru";
  return fallback;
}
function resolveInitialLocale(storageKey, fallback) {
  if (typeof window === "undefined") return fallback;
  try {
    const persisted = window.localStorage.getItem(storageKey);
    if (persisted) return normalizeLocale(persisted, fallback);
  } catch {
  }
  const candidates = window.navigator.languages?.length ? window.navigator.languages : [window.navigator.language];
  for (const candidate of candidates) {
    const normalized = candidate?.trim().toLowerCase();
    if (normalized?.startsWith("en")) return "en";
    if (normalized?.startsWith("ru")) return "ru";
  }
  return fallback;
}
function I18nProvider({
  locale: controlledLocale,
  defaultLocale = "ru",
  storageKey = DEFAULT_STORAGE_KEY,
  messages,
  onLocaleChange,
  children
}) {
  const [internalLocale, setInternalLocale] = useState(
    () => resolveInitialLocale(storageKey, defaultLocale)
  );
  const locale = controlledLocale ?? internalLocale;
  const merged = useMemo(() => {
    const out = { ...DEFAULT_CATALOGS };
    if (messages) {
      for (const loc of ["ru", "en"]) {
        const cat = messages[loc];
        if (!cat) continue;
        out[loc] = { ...out[loc] ?? {}, ...cat };
      }
    }
    return out;
  }, [messages]);
  const t = useCallback(
    (key, params) => {
      const primary = merged[locale]?.[key];
      const fallback = merged.en?.[key];
      let raw = primary ?? fallback ?? key;
      if (params) {
        for (const [k, v] of Object.entries(params)) {
          raw = raw.replaceAll(`{${k}}`, String(v));
        }
      }
      return raw;
    },
    [merged, locale]
  );
  const setLocale = useCallback(
    (nextLocale) => {
      const normalized = normalizeLocale(nextLocale, defaultLocale);
      if (controlledLocale === void 0) setInternalLocale(normalized);
      try {
        window.localStorage.setItem(storageKey, normalized);
      } catch {
      }
      onLocaleChange?.(normalized);
    },
    [controlledLocale, defaultLocale, onLocaleChange, storageKey]
  );
  useEffect(() => {
    document.documentElement.lang = locale;
    try {
      window.localStorage.setItem(storageKey, locale);
    } catch {
    }
  }, [locale, storageKey]);
  const ctx = useMemo(
    () => ({
      locale,
      setLocale,
      t
    }),
    [locale, setLocale, t]
  );
  return /* @__PURE__ */ jsx(I18nContext.Provider, { value: ctx, children });
}
function useTranslation() {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    return (key) => key;
  }
  return ctx.t;
}
function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error("useI18n must be used within <I18nProvider>");
  }
  return ctx;
}
function LocaleSwitcher({ compact = true, className = "", ...props }) {
  const { locale, setLocale, t } = useI18n();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...props,
      className: `iam-locale-switcher${compact ? " is-compact" : ""} ${className}`.trim(),
      role: "group",
      "aria-label": t("locale.switcher"),
      children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: locale === "ru" ? "is-active" : "",
            "aria-pressed": locale === "ru",
            "aria-label": locale === "ru" ? t("locale.russian") : t("locale.switch_to_russian"),
            onClick: () => setLocale("ru"),
            children: "RU"
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: locale === "en" ? "is-active" : "",
            "aria-pressed": locale === "en",
            "aria-label": locale === "en" ? t("locale.english") : t("locale.switch_to_english"),
            onClick: () => setLocale("en"),
            children: "EN"
          }
        )
      ]
    }
  );
}

export { I18nProvider, LocaleSwitcher, normalizeLocale, useI18n, useTranslation };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map